module.exports = __webpack_public_path__ + "media/images/plan-1944441e.png";